<template>
  <div class="TileData px-3 pb-4 pt-0">
    <div class="TileData__title d-flex">
      <span class="align-self-center">
        PROGNOSE - 
        <span class="TileData__highlighted">{{ year }}</span> - 
        <span class="TileData__highlighted">{{ accessLabel }}</span>
      </span>
    </div>
    <div v-if="fid">
      <table>
        <tbody>
          <tr :class="{ 'TileData__highlighted': this.decisive.includes('inhabitants') }">
            <td class="d-block mr-4">Bewoners</td>
            <td>{{ inhabitants }}{{ atLimit(inhabitants) ? '+': '' }} EV's</td>
          </tr>
          <tr :class="{ 'TileData__highlighted': this.decisive.includes('visitors') }">
            <td>Bezoekers</td>
            <td>{{ visitors }}{{ atLimit(visitors) ? '+': '' }} EV's</td>
          </tr>
          <tr :class="{ 'TileData__highlighted': this.decisive.includes('commuters') }">
            <td>Forenzen</td>
            <td>{{ commuters }}{{ atLimit(commuters) ? '+': '' }} EV's</td>
          </tr>
        </tbody>
      </table>
      <div class="mt-2 text-muted">
        ID: {{ fid }}
      </div>
    </div>
    <div v-else>
      Klik op een vlak om de prognose data te bekijken.
    </div>
  </div>
</template>

<script>

import { limitEV } from 'config/limit-ev'
import { decielen } from 'config/inkomensdecielen'

import { mapGetters, mapMutations } from 'vuex';

export default {
  props: {
    loaded: {
      type: Boolean,
      value: false
    }
  },
  data() {
    return {
      BewonersD1: null,
      BewonersD2: null,
      BewonersD3: null,
      BewonersD4: null,
      BewonersD5: null,
      Bezoekers: null,
      Forenzen: null,
      Pubparkeer: null,

      fid: false
    }
  },
  computed: {
    ...mapGetters('map', [
      'getForecastStatus',
      'getHighlighted',
      'getEditMode'
    ]),

    // Controls
    model() {
      return this.getForecastStatus.model
    },
    year() {
      return this.getForecastStatus.year
    },
    access() {
      return this.getForecastStatus.access
    },
    forecast() {
      return this.getForecastStatus.forecast
    },

    // Access label
    accessLabel() {
      return this.access === 'public' ? 'Publiek' : 'Privaat'
    },

    // parking factor
    parkingFactor() {
      return this.access === 'public' 
        ? this.Pubparkeer || 0
        : (1 - this.Pubparkeer)
    },
    yearFactor() { 
      return decielen[this.model].D4[this.year] || 0
    },

    // Figures
    inhabitants() {
      let base = 0;

      base = base + this.BewonersD1 * decielen[this.model].D1[this.year]
      base = base + this.BewonersD2 * decielen[this.model].D2[this.year]
      base = base + this.BewonersD3 * decielen[this.model].D3[this.year]
      base = base + this.BewonersD4 * decielen[this.model].D4[this.year]
      base = base + this.BewonersD5 * decielen[this.model].D5[this.year]
      
      return this.limit(this.oneDecimal((base || 0) * this.parkingFactor))
    },
    commuters() {
      return this.limit(this.oneDecimal((this.Forenzen || 0) * this.yearFactor * this.parkingFactor))
    },
    visitors() {
      return this.limit(this.oneDecimal((this.Bezoekers || 0) * this.yearFactor * this.parkingFactor))
    },

    // Decisive
    decisive() {
      let highscore = Math.max(this.visitors, this.commuters, this.inhabitants)
      return ['inhabitants', 'commuters', 'visitors'].filter((key) => {
        return (parseFloat(this[key], 10) === highscore)
      })
    }
  },
  watch: {
    loaded: function() {
      this.$store.map.on('click', 'hexagons', this.selectTile)
      
      // Cursor on hover
      this.$store.map.on('mouseenter', 'hexagons', () => {
        this.$store.map.getCanvas().style.cursor = 'pointer'
      });
      this.$store.map.on('mouseleave', 'hexagons', () => {
        this.$store.map.getCanvas().style.cursor = ''
      });
    }
  },
  methods: {
    ...mapMutations('map', [
      'setHighlighted'
    ]),
    oneDecimal(num) {
      return (Math.round((num * 10)) / 10).toFixed(1)
    },
    atLimit(num) {
      return num === limitEV
    },
    limit(num) {
      return num > limitEV ? limitEV : num
    },
    selectTile(e) {
      if (e.features.length === 0 || this.getEditMode || e._defaultPrevented) {
        return 
      }

      // console.log(e.features[0].properties)
      
      Object.keys(this._data)
        .forEach((key) => {
          this[key] = e.features[0].properties[key] || null;
        })
      
      if (this.getHighlighted === this.fid) {
        this.setHighlighted({ fid: false })
      } else {
        this.setHighlighted({ fid: this.fid })
      }
    }
  }
}
</script>

<style lang="scss">
.TileData {
  // height: 300px;
  width: 200px;
  background: #081736; //white;
  color: white; // #7F8FA4;
  padding: 10px 15px 25px;
  box-shadow: 0px -1px 0px 0px rgba(223,226,229,1) inset;


  &__title {
    height: 60px;
  }

  &__highlighted {
    color: #ff883c;
  }
}
</style>
